import React from "react";
import { ExternalLink, Code, Calendar } from "lucide-react";
import { Button } from "./ui/button";
import { Card } from "./ui/card";
import { Badge } from "./ui/badge";
import { portfolioData } from "../data/mock";

const Projects = () => {
  const { projects } = portfolioData;

  return (
    <section id="projects" className="py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="bg-gradient-to-r from-cyan-400 to-violet-500 bg-clip-text text-transparent">
              Mes Réalisations
            </span>
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">
            Découvrez quelques-uns de mes projets les plus récents et les technologies utilisées
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {projects.map((project, index) => (
            <Card
              key={project.id}
              className="group bg-slate-800/50 border-slate-700 hover:border-cyan-500/50 transition-all duration-500 hover:shadow-2xl hover:shadow-cyan-500/10 overflow-hidden"
            >
              {/* Project Image */}
              <div className="relative overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-4 right-4">
                  <Badge className="bg-gradient-to-r from-cyan-500 to-violet-500 text-white">
                    {project.category}
                  </Badge>
                </div>
              </div>

              {/* Project Content */}
              <div className="p-6 space-y-4">
                <div className="space-y-2">
                  <h3 className="text-2xl font-bold text-white group-hover:text-cyan-400 transition-colors duration-300">
                    {project.title}
                  </h3>
                  <p className="text-slate-400 leading-relaxed">
                    {project.description}
                  </p>
                </div>

                {/* Technologies */}
                <div className="space-y-2">
                  <div className="flex items-center space-x-2 text-slate-500">
                    <Code size={16} />
                    <span className="text-sm">Technologies utilisées :</span>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {project.technologies.map((tech, techIndex) => (
                      <Badge
                        key={techIndex}
                        variant="outline"
                        className="text-slate-300 border-slate-600 hover:border-cyan-500 hover:text-cyan-400 transition-colors duration-300"
                      >
                        {tech}
                      </Badge>
                    ))}
                  </div>
                </div>

                {/* Action Button */}
                <div className="pt-4">
                  <Button
                    className="w-full bg-gradient-to-r from-cyan-500 to-violet-500 hover:from-cyan-600 hover:to-violet-600 text-white group-hover:shadow-lg group-hover:shadow-cyan-500/25 transition-all duration-300"
                    onClick={() => window.open(project.url, '_blank')}
                  >
                    <ExternalLink className="mr-2" size={16} />
                    Voir le site
                  </Button>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-slate-800/50 to-slate-700/50 p-8 rounded-2xl border border-slate-700">
            <h3 className="text-2xl font-bold text-white mb-4">
              Vous avez un projet en tête ?
            </h3>
            <p className="text-slate-400 mb-6 max-w-2xl mx-auto">
              Ces réalisations vous inspirent ? Discutons ensemble de votre projet et créons quelque chose d'exceptionnel.
            </p>
            <Button
              className="bg-gradient-to-r from-cyan-500 to-violet-500 hover:from-cyan-600 hover:to-violet-600 text-white px-8 py-3 text-lg hover:shadow-lg hover:shadow-cyan-500/25 transition-all duration-300"
              onClick={() => {
                const element = document.getElementById("contact");
                if (element) element.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Démarrons votre projet
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;